import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

/**
 * LearningStore — global UI state shared across Ollie Learns surfaces.
 *
 * Currently just the reader's self-selected reading level. The landing
 * page hero owns the segmented control; other Learns surfaces (and
 * eventually Library integrations) can read the same value to pre-filter
 * content without re-asking.
 *
 * Persisted to localStorage so the selection survives a reload. Defaults
 * to `'5–6'` per the landing spec (§5d).
 */
export type ReadingLevel = '3–4' | '5–6' | '7–8';

export const READING_LEVELS: ReadingLevel[] = ['3–4', '5–6', '7–8'];

export interface LearningState {
  readingLevel: ReadingLevel;
  setReadingLevel: (level: ReadingLevel) => void;
}

export const useLearningStore = create<LearningState>()(
  persist(
    (set) => ({
      readingLevel: '5–6',
      setReadingLevel: (readingLevel) => set({ readingLevel }),
    }),
    {
      name: 'learning-store',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
